import styled from 'styled-components';
import { Title as Tit } from '../Signup/styled';
export { Wrapper, Title, Paragraph } from '../Signup/styled';

export const Subtitle = styled(Tit)`
  font-size: 1.6rem;
  font-weight: ${({ theme }) => theme.fonts.font_regular};
`;
